import { Component } from 'react';
import PropTypes from 'prop-types';

export default class ImageGallery extends Component {
  constructor(props) {
    super(props);
    this.initCarousel = this.initCarousel.bind(this);
  }

  componentDidMount() {
    this.initCarousel();
  }

  initCarousel() {
    const { mainCarouselCustomProperties, thumbsCarouselCustomProperties } =
      this.props;

    const thumbsCarousel = window.makeCarousel(this.thumbCarouselRef, {
      perPage: 5,
      perMove: 1,
      lazyLoad: 'nearby',
      preloadPages: 0,
      drag: true,
      direction: 'ttb',
      height: 589,
      width: 119,
      gap: 4,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: {
        992: {
          direction: 'ltr',
          width: '100%',
          height: null,
          gap: 0,
        },
      },
      ...thumbsCarouselCustomProperties,
    });

    const carousel = window.makeCarousel(this.carouselRef, {
      perPage: 1,
      perMove: 1,
      pagination: true,
      lazyLoad: 'nearby',
      arrows: true,
      preloadPages: 0,
      ...mainCarouselCustomProperties,
    });

    carousel.sync(thumbsCarousel);

    return carousel;
  }

  render() {
    const { images, lazyFirstImage } = this.props;

    return (
      <div className="splide-wrapper splide-wrapper--images-gallery container">
        <section
          className="splide main-carousel"
          aria-label="Galeria de imagens"
          ref={node => {
            this.carouselRef = node;
          }}
        >
          <div className="splide__track">
            <div className="splide__list">
              {images.map((image_item, index) => {
                const loadType =
                  !lazyFirstImage && index === 0 ? 'eager' : 'lazy';

                return (
                  <div className="splide__slide">
                    <img
                      src={image_item.main_image}
                      alt="Imagem do veículo"
                      className="gallery-image"
                      width={950}
                      height={535}
                      loading={loadType}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section
          className="splide thumbnail-carousel"
          aria-label="Carrossel de miniaturas da galeria de imagens. Selecionar uma miniatura irá alterar a imagem atual da galeria."
          ref={node => {
            this.thumbCarouselRef = node;
          }}
        >
          <div className="splide__track">
            <div className="splide__list">
              {images.map(image_item => (
                <div className="splide__slide">
                  <img
                    src={image_item.thumb_image}
                    width={310}
                    height={310}
                    alt="Thumb"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

ImageGallery.defaultProps = {
  images: [],
  mainCarouselCustomProperties: null,
  thumbsCarouselCustomProperties: null,
  lazyFirstImage: true,
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      main_image: PropTypes.string,
      thumb_image: PropTypes.string,
    }),
  ),
  mainCarouselCustomProperties: PropTypes.shape({}),
  thumbsCarouselCustomProperties: PropTypes.shape({}),
  lazyFirstImage: PropTypes.bool,
};
